import i18n from '@translations/i18n';

/**
 * @param {object} enumObject
 * @param {string} path
 */
// eslint-disable-next-line import/prefer-default-export
export const enumToListObject = (enumObject, path) => Object.keys(enumObject).map((key) => ({
    id: enumObject[key],
    name: i18n.t(`${path}.${[key]}`, { ns: 'bidEnums' }),
}));

export const enumToLabelValueOptions = (enumObject, path) => enumToListObject(enumObject, path)
    .map((option) => ({
        value: option.id,
        label: option.name,
    }));
